import { render, staticRenderFns } from "./EvaluationFileTools.vue?vue&type=template&id=b488bd16&scoped=true&"
import script from "./EvaluationFileTools.vue?vue&type=script&lang=js&"
export * from "./EvaluationFileTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b488bd16",
  null
  
)

export default component.exports